import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient.js';
import InvitationsRow from './InvitationsRow.jsx';
import ExcelExportButton from '../../assets/ExcelExportButton.jsx';
import Loader from '../../assets/tools/Loder/loader';
import { DataTable, PageHeader, PageToolbar } from '../../componants/Workspace';

const Invitations = () => {
  const [invitations, setInvitations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [invitationsPerPage] = useState(50);
  const [filter, setFilter] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortOrder, setSortOrder] = useState('asc'); // Default sorting order

  const fetchData = async () => {
    try {
      const response = await AxiosClient.get('/invitations');
      setInvitations(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString()); // Default: current year

  useEffect(() => {
    fetchData();
  }, []);

  const handleDeleteArt = async (id) => {
    try {
      await AxiosClient.delete(`/invitations/${id}`);
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };
 // Extract unique years from `expired_at`
 const availableYears = Array.from(
  new Set(invitations.map((inv) => new Date(inv.expired_at).getFullYear()))
).sort((a, b) => b - a); // Sort years descending


  const handleFilter = (status) => {
    setFilter(status);
    setSearchTerm('');
    setCurrentPage(1);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setFilter(null);
    setCurrentPage(1);
  };

  
  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    setCurrentPage(1);
  };

  // Apply filters
  let filteredInvitations = invitations;
  if (filter === 'pending') {
    filteredInvitations = invitations.filter((invitation) => invitation.status === 'pending');
  } else if (filter === 'accepted') {
    filteredInvitations = invitations.filter((invitation) => invitation.status === 'accepted');
  }

  // Apply search filter
  filteredInvitations = filteredInvitations.filter((invitation) =>
    invitation.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

 
  if (selectedYear) {
    filteredInvitations = filteredInvitations.filter(
      (inv) => new Date(inv.expired_at).getFullYear().toString() === selectedYear
    );
  }
  

  const indexOfLastInvitation = currentPage * invitationsPerPage;
  const indexOfFirstInvitation = indexOfLastInvitation - invitationsPerPage;
  const currentInvitations = filteredInvitations.slice(indexOfFirstInvitation, indexOfLastInvitation);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <PageHeader
        title="Invitations"
        description="Create invitation codes and monitor their use."
        actions={(
          <>
            <Link to="./Add" className="btn btn-primary">
              <i className="material-icons" aria-hidden="true">add</i>
              Generate code
            </Link>
            <Link to="./Add/excel" className="btn btn-outline-secondary">
              <i className="material-icons" aria-hidden="true">upload_file</i>
              Generate from Excel
            </Link>
          </>
        )}
      />

      <PageToolbar
        filters={(
          <>
            <div className="workspace-segmented" role="group" aria-label="Filter invitations by status">
              {[
                [null, 'All'],
                ['pending', 'Active'],
                ['accepted', 'Passed'],
              ].map(([status, label]) => (
                <button
                  key={label}
                  type="button"
                  className={`btn ${filter === status ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => handleFilter(status)}
                  aria-pressed={filter === status}
                >
                  {label}
                </button>
              ))}
            </div>
            <input
              type="search"
              aria-label="Search invitations by title"
              placeholder="Search by title"
              value={searchTerm}
              onChange={handleSearch}
              className="form-control workspace-search"
            />
            <label className="workspace-filter-group">
              <span className="workspace-filter-group__label">Year</span>
              <select value={selectedYear} onChange={handleYearChange} className="form-select">
                <option value="">All years</option>
                {availableYears.map((year) => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
            </label>
          </>
        )}
        actions={<ExcelExportButton data={filteredInvitations} fileName="invitations" label="Export filtered" />}
      />

      {loading ? (
        <div className="workspace-loading"><Loader label="Loading invitations..." /></div>
      ) : (
        <DataTable>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Code</th>
                  <th>Status</th>
                  <th>User Used</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentInvitations.map((invit_item) => (
                  <InvitationsRow
                    key={invit_item.id}
                    title={invit_item.title}
                    invitation_code={invit_item.invitation_code}
                    user={invit_item.user}
                    status={invit_item.status}
                    expired_at={invit_item.expired_at}
                    id={invit_item.id}
                    onDelete={handleDeleteArt}
                  />
                ))}
              </tbody>
        </DataTable>
      )}

      {!loading && filteredInvitations.length > invitationsPerPage && (
        <nav className="workspace-pagination" aria-label="Invitation pages">
          <ul className="pagination mb-0">
            {Array.from({ length: Math.ceil(filteredInvitations.length / invitationsPerPage) }).map((_, index) => (
              <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                <button className="page-link" onClick={() => paginate(index + 1)} aria-current={currentPage === index + 1 ? 'page' : undefined}>
                  {index + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </>
  );
};

export default Invitations;
